import { MoreVert } from '@mui/icons-material';
import {
  Typography,
  List,
  Paper,
  IconButton,
  Divider,
  Stack,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import { CadencePlayer } from '../types';
import { useState } from 'react';
import CadencePlayerItem from './CadencePlayerItem';

type PlayerCadenceWeekCardProps = {
  readonly date: string;
  readonly players: readonly CadencePlayer[];
};

export default function PlayerCadenceWeekCard({
  date,
  players,
}: PlayerCadenceWeekCardProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleCopy = () => {
    handleCloseMenu();
    navigator.clipboard.writeText(
      players.map((player) => player.name).join('\n')
    );
  };

  return (
    <Paper
      elevation={4}
      sx={{
        padding: 2,
        display: 'flex',
        flexDirection: 'column',
        mb: {
          xs: 3,
          sm: 3,
          md: 3,
          lg: 0,
          xl: 0,
        },
        minWidth: {
          lg: '320px',
        },
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography
          variant="button"
          sx={{ fontSize: 18, textTransform: 'none' }}
        >
          Date: {date}
        </Typography>
        <IconButton onClick={handleOpenMenu}>
          <MoreVert />
        </IconButton>
      </Stack>
      <Divider sx={{ mt: 1 }} />
      <List style={{ height: '100%' }}>
        {players.map((player) => (
          <CadencePlayerItem
            key={player.name}
            player={player}
            showAppearances
          />
        ))}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleCloseMenu}
        >
          <MenuItem onClick={handleCopy}>
            <ListItemIcon>
              <ContentCopyIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Copy</ListItemText>
          </MenuItem>
        </Menu>
      </List>
    </Paper>
  );
}
